module.exports = __webpack_public_path__ + "img/7_160.695c1101.png";